export default function anonymous(it
) {
var out='<div class="slogan '+((it.isHidden?'hidden':''))+'"> <div class="slogan__container"> <div class="slogan__container__line"></div> <div class="slogan__container__text">'+(it.slogan)+'</div> </div></div>';return out;
}